import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { MaterialCatalogBoard } from '@api/BoardSDK';
import { readRateCardConfig } from '@generated/server/rate-card.server';

export const getMaterials = createServerFn({ method: 'GET' })
  .validator(z.object({}).optional())
  .handler(async () => {
    const board = new MaterialCatalogBoard();
    const res = await board
      .items()
      .withColumns(['fillLbs', 'requiresUpload', 'sort', 'examples', 'mapsTo', 'active'])
      .where({ active: true })
      .orderBy({ column: 'sort', direction: 'asc' })
      .withPagination({ limit: 100 })
      .execute();
    return { items: res.items };
  });

export const getRateCardConfig = createServerFn({ method: 'GET' })
  .validator(z.object({}).optional())
  .handler(async () => readRateCardConfig());
